import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { NarrowWrapper } from 'shared/ui/layout/NarrowWrapper'
import { ConnectWalletScreen } from 'modules/wallet/ui/ConnectWalletScreen'

type Args = {
  isCentered?: boolean
}

export function withWalletConnectCheck<P>(
  Wrapped: React.ComponentType<P>,
  { isCentered }: Args = {},
) {
  return function WalletConnectCheck(props: P) {
    const { isWalletConnected } = useWeb3()

    if (isWalletConnected) {
      return <Wrapped {...props} />
    }

    return (
      <NarrowWrapper style={isCentered ? { margin: '0 auto' } : undefined}>
        <ConnectWalletScreen />
      </NarrowWrapper>
    )
  }
}
